import React from "react"
//import I18n from "i18n-js/index.js.erb"
import clsx from "clsx"

class PortalCustomerBuilderGeneral extends React.Component {
	constructor(props) {
		super(props)
	}

	render() {
		var tabClasses = clsx({
			'active': this.props.active_tab == 'general',
			'tab-pane': true,
    })
    
    if(this.props.reset_password) {
      return (
        <div className={tabClasses} id="general">
          <div className="row">
            <div className="col-sm-4">
              <div className="form-group">
                <label>{I18n.t('old_password')}*</label>
                <input type="text" name="old_password" value={this.props.old_password ? this.props.old_password : ''} className="form-control" onChange={this.props.onChange} />
              </div>
            </div>

            <div className="col-sm-4">
              <div className="form-group">
                <label>{I18n.t('new_password')}*</label>
                <input type="text" name="new_password" value={this.props.new_password ? this.props.new_password : ''} className="form-control" onChange={this.props.onChange} />
              </div>
            </div>

            <div className="col-sm-4">
              <div className="form-group">
                <label>{I18n.t('password_confirmation')}*</label>
                <input type="text" name="confirm_password" value={this.props.confirm_password ? this.props.confirm_password : ''} className="form-control" onChange={this.props.onChange} />
              </div>
            </div>
          </div>
        </div>
      )
    }

		return (
      <div className={tabClasses} id="general">
        <div className="row">
          <div className="col-sm-1">
            <div className="form-group">
              <label>{I18n.t('salutation')}</label>
              <input type="text" name="salutation" value={this.props.salutation ? this.props.salutation : ''} className="form-control" onChange={this.props.onChange} />

            </div>
          </div>

          <div className="col-sm-4">
            <div className="form-group">
              <label>{I18n.t('first_name')}*</label>
              <input type="text" name="first_name" value={this.props.first_name ? this.props.first_name : ''} className="form-control" onChange={this.props.onChange} />
            </div>
          </div>

          <div className="col-sm-3">
            <div className="form-group">
              <label>{I18n.t('middle_name')}</label>
              <input type="text" name="middle_name" value={this.props.middle_name ? this.props.middle_name : ''} className="form-control" onChange={this.props.onChange} />
            </div>
          </div>

          <div className="col-sm-4">
            <div className="form-group">
              <label>{I18n.t('last_name')}*</label>
              <input type="text" name="last_name" value={this.props.last_name ? this.props.last_name : ''} className="form-control" onChange={this.props.onChange} />
            </div>
          </div>

        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{I18n.t('email_address')}*</label>
              <input type="text" name="email" value={this.props.email ? this.props.email : ''} className="form-control" onChange={this.props.onChange} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{I18n.t('mobile_number')}</label>
              <input type="text" name="formatted_phone" value={this.props.formatted_phone ? this.props.formatted_phone : ''} className="form-control" onChange={this.props.onChange} />
            </div>
          </div>

        </div>

        <hr />

        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{I18n.t('address_1')} </label>
              <input type="text" id="autocomplete" name="address_1" value={this.props.address_1 ? this.props.address_1 : ''} className="form-control" onChange={this.props.onChange} />
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group">
              <label>{I18n.t('address_2')}</label>
              <input type="text" name="address_2" value={this.props.address_2 ? this.props.address_2 : ''} className="form-control" onChange={this.props.onChange} />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-3">
            <div className="form-group">
              <label>{I18n.t('city')} </label>
              <input type="text" name="city" value={this.props.city ? this.props.city : ''} className="form-control" onChange={this.props.onChange} />
            </div>
          </div>

          <div className="col-sm-3">
            <div className="form-group">
              <label>{I18n.t('state_province')} </label>
              <input type="text" name="state" value={this.props.state ? this.props.state : ''} className="form-control" onChange={this.props.onChange} />
            </div>
          </div>

          <div className="col-sm-3">
            <div className="form-group">
              <label>{I18n.t('postal_code')} </label>
              <input type="text" name="postal_code" value={this.props.postal_code ? this.props.postal_code : ''} className="form-control" onChange={this.props.onChange} />
            </div>
          </div>

          <div className="col-sm-3">
            <div className="form-group">
              <label>{I18n.t('country')} </label>
              <input type="text" name="country" value={this.props.country ? this.props.country : ''} className="form-control" onChange={this.props.onChange} />
            </div>
          </div>
        </div>

      </div>
		);
	}
}

export default PortalCustomerBuilderGeneral